<div class="container background">
    <div class="btn-close" (click)="onClose()">
        <i class="fa fa-close"></i>
    </div>
    <div class="margin">
        <ng-image-slider class="imageslider" [images]="data.images" [imageSize]="data.imageSize"></ng-image-slider>
    </div>
</div>

